import Vue from 'vue';

Vue.directive('click-out', {
  bind: (el, binding) => {
    el.vClickOut = function (e) {
      if (!el.contains(e.target)) {
        if (typeof binding.value === 'function') binding.value()
      }
    }

    setTimeout(function () {
      document.body.addEventListener('click', el.vClickOut)
    })
  },
  unbind: (el) => {
    document.body.removeEventListener('click', el.vClickOut)
  },
});

